import type { Rental } from "./rental";
import * as consts from "./consts";

const getExchangeRate = (exchangeRates: Record<string, number>, displayCurrency: string, priceCurrency: string): number =>
    exchangeRates[displayCurrency] / exchangeRates[priceCurrency];

export const getDisplayPrice = (rental: Rental, exchangeRates: Record<string, number>, displayCurrency: string): number | null => {
    if (!rental.price_per_month || !isFinite(rental.price_per_month as number)) return null;
    const rate = getExchangeRate(exchangeRates, displayCurrency, rental.price_currency || consts.BASE_CURRENCY);
    if (!rate || !isFinite(rate)) return null;
    return Math.round(rental.price_per_month * rate);
};
export const formatPrice = (amount: number | null, currency: string): string => {
    if (!amount) return '';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0,
    }).format(amount);
};

